import {Component, OnInit, OnDestroy,ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {NgbModal ,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'app-escalat-master',
  templateUrl: './escalat-master.component.html',
  styleUrls: ['./escalat-master.component.css']
})
export class EscalatMasterComponent implements OnInit, OnDestroy {
    categorySelected: string;
    show: boolean;
    dataset: any[];
    totalData: number;
    respObject: any;
    categories = [];
    category: string;
    resolverGroup: string;
    resolverUser: string;
    categoryArr = [];
    ticket_status = [];
    ststusSelected: number;
    status_sequence: number;
    ticketStatus: string;
    ticketTypeSeqNo: number;
    displayData: any;
    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    private clientId: number;
    tickets = [];
    ticketSelected: number;
    type: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    offset: number;
    radioChecked: number;
    dataLoaded:boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    categrySelected: any;
    escalates: any;
    status: string;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
      this.notifier = notifier;
      this.messageService.getCellChangeData().subscribe(item => {
          switch (item.type) {
              case 'change':
                  console.log('changed');
                  if (!this.messageService.edit) {
                      this.notifier.notify('error', 'You do not have edit permission');
                  } else {

                  }
                  break;
              case 'delete':
                  // console.log('deleted');
                  if (!this.messageService.del) {
                      this.notifier.notify('error', 'You do not have delete permission');
                  } else {
                      if (confirm('Are you sure?')) {
                          this._rest.deleteEscalatePrcessConfig({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                              this.respObject = res;
                              if (this.respObject.success) {
                                  // this.totalData = this.totalData - 1;
                                  // this.messageService.setTotalData(this.totalData);
                                  this.messageService.sendAfterDelete(item.id);
                              } else {
                                  this.notifier.notify('error', this.respObject.errorMessage);
                              }
                          }, (err) => {
                              this.notifier.notify('error', this.respObject.errorMessage);
                          });
                      }
                  }
                  break;
          }
      });
  }

    ngOnInit() {
        this.dataLoaded=false;
        this.ststusSelected = 0;
        this.resolverGroup = 'false';
        this.resolverUser = 'false';
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: ' Maintain Ticket Process Flow',
            openModalButton: ' Add Ticket Process Flow',
            searchModalButton: 'Search',
            breadcrumb: 'Ticket Process Flow',
            folderName: 'All Ticket Process Flow',
            tabName: 'Ticket Process Flow',
            exportBtn: 'Export to excel'

        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'type', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true
            },
            {
                id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true
            },
            {
                id: 'status', name: 'Status', field: 'status', sortable: true, filterable: true
            },
            {
                id: 'resolverGroup', name: 'Resolver Group', field: 'resolverGroup', sortable: true, filterable: true
            },
            {
                id: 'resolverUser', name: 'Resolver User', field: 'resolverUser', sortable: true, filterable: true
            },
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    onCategoryChange(selectedIndex) {
        this.category = this.categories[selectedIndex].name;
    }

    onStatusChange(selectedIndex: any) {
        this.ticketStatus = this.ticket_status[selectedIndex].status;
        this.status_sequence = this.ticket_status[selectedIndex].sequence;
    }
    exportToExcel() {
        this.isExportDisable = true;
        // console.log("okkk" +this.clientId);
        this._rest.getAllEscalateMaster(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable = false;
                this.dataExcel = this.respObject.details;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.ticketSelected = 0;
            this.categorySelected = '0';
            this.resolverUser = 'false';
            this.resolverGroup = 'false';
            this.categoryArr = [];
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {
            });
        }
    }


    searchModal() {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.ticketSelected = 0;
            this.categorySelected = '0';
            this.resolverUser = 'false';
            this.resolverGroup = 'false';
            this.categoryArr = [];
            this.status = '';
            this.categrySelected = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
        }
    }


    getDetails() {
        for (let i = 0; i < this.escalates.length; i++) {
            if (this.escalates[i].category === this.categrySelected) {
               
                this.status = this.escalates[i].status;
            }
        }
    }
    search() {
        this._rest.searchAllEscalateMaster(this.categrySelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.escalates = this.respObject.details;
                this.messageService.setTotalData(this.escalates.length);
                this.messageService.setGridData(this.escalates);
                this.searchModalReference.close();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    save() {
        const data = {
            clientId: this.clientId,
            ticketTypeId: this.ticketSelected,
            resolverGroup: this.resolverGroup,
            resolverUser: this.resolverUser,
            status_sequence: this.status_sequence,
            createdBy: this.messageService.getUserId()
        };
        if (this.categorySelected === '-1') {
            data['category_id'] = this.categoryArr;
        } else {
            this.categoryArr = [];
            this.categoryArr.push(this.categorySelected)
            data['category_id'] = this.categoryArr;
        }
        // console.log('DDDDDDDDDDDDDDDDDDDD====' + JSON.stringify(data));
        if (!this.messageService.isBlankField(data) && (this.resolverGroup !== this.resolverUser) && this.categorySelected !== '0') {
            this._rest.insertEscalatePrcessConfig(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.categoryArr = [];
                    this.ticketSelected = 0;
                    this.categorySelected = '0';
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getEscalatePrcessConfig(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onTicketChange(selectedIndex: any) {
        this.type = this.tickets[selectedIndex].name;
        this.ticketTypeSeqNo = this.tickets[selectedIndex].seq;
        this._rest.getStatusByTicketTypeLt(this.ticketTypeSeqNo, this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.details.unshift({id: 0, status: 'Select Ticket Status'});
                this.ticket_status = this.respObject.details;
                // console.log('status==========' + this.ticket_status);
                this.ststusSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });

        this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Category'}, {id: -1, name: 'Select All'});
                this.categories = this.respObject.details;
                for (let i = 2; i < this.categories.length; i++) {
                    this.categoryArr.push(this.categories[i].id);
                }
                this.categorySelected = '0';
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onRadioButtonChange(selectedValue) {
        this.radioChecked = selectedValue.value;
        if (this.radioChecked === 1) {
          this.resolverGroup = 'true';
            this.resolverUser = 'false';
        } else {
            this.resolverUser = 'true';
            this.resolverGroup = 'false';
        }
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

}
